import { render } from "./GSM.vue?vue&type=template&id=072be332"
import script from "./GSM.vue?vue&type=script&lang=js"
export * from "./GSM.vue?vue&type=script&lang=js"

import exportComponent from "D:\\agents\\Oreo\\_work\\93\\s\\NcasReporting\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__